import React from 'react'
import { ArrowClockwise } from 'react-bootstrap-icons'

import { colors } from '../../../constants/salesStyles'

import styles from './styles.module.scss'

interface IProps {
    previewAngle: number
    isDisabled?: boolean
    onRotate: () => void
    children: React.ReactNode
}

const ImageRotateControls = ({ previewAngle, isDisabled = false, onRotate, children }: IProps) => (
    <div className={styles.wrap}>
        <div
            className={`${styles.preview} ${isDisabled ? styles.previewSaving : ''}`}
            style={{ transform: previewAngle ? `rotate(${previewAngle}deg)` : undefined }}
        >
            {children}
        </div>
        <button
            type="button"
            className={styles.rotateIcon}
            onClick={onRotate}
            disabled={isDisabled}
            title="Повернуть"
        >
            <ArrowClockwise color={colors.blueDark} size={14} />
        </button>
    </div>
)

export default ImageRotateControls
